"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _StateHelper = _interopRequireDefault(require("../helpers/StateHelper.js"));
var _QuestionBank = _interopRequireDefault(require("../factories/QuestionBank.js"));
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = new _StateHelper.default(_QuestionBank.default);
var initialState = stateHelper.initialState;
exports.initialState = initialState;
var reducers = {};
reducers[_constants.QUESTION_BANK_FETCHED] = stateHelper.set;
reducers[_constants.QUESTION_BANKS_FETCHED] = stateHelper.set;
reducers[_constants.QUESTION_BANK_SELECTED] = stateHelper.set;

// Non-QuestionBanks Action Reducers
reducers[_constants.SESSION_FETCHED] = stateHelper.resetAndSet;
reducers[_constants.SESSION_RESET] = stateHelper.reset;
reducers[_constants.USER_SUBSCRIPTIONS_FETCHED] = stateHelper.set;
reducers[_constants.PRODUCTS_FETCHED] = stateHelper.set;
reducers[_constants.PRODUCT_IAP_SYNCED] = stateHelper.set;
reducers[_constants.CME_ACTIVITIES_FETCHED] = stateHelper.set;

// B2B fetch
reducers[_constants.QUESTION_BANK_NAMES_FETCHED] = function addNames(state, payload) {
  return state.withMutations(function (newState) {
    Object.entries(payload).forEach(function (questionBank) {
      newState.set(questionBank[1][0], new _QuestionBank.default({
        id: questionBank[1][0],
        attributes: {
          name: questionBank[1][1]
        }
      }));
    });
  });
};
var _default = exports.default = stateHelper.createReducer(reducers);